import React, {useEffect, useState} from 'react';
import {API_BASE_URL, AUTH_TOKEN} from "../../config/config";
import {Col, Image, Row, Spin} from "antd";
import EXIF from "exif-js";
import {useTranslation} from "react-i18next";

interface IImageWithAuth {
  src: string;
  scId: number;
  tag?: string;
  xmlDataScFamilyPhoto?: string;
  viewMetadata?: boolean;
  folder?: string;
}
function ImageWithAuth({src, scId, tag, xmlDataScFamilyPhoto, viewMetadata, folder = 'members'}: IImageWithAuth) {
  const [image, setImage] = useState<any>(null);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [familyPhoto, setFamilyPhoto] = useState<any>({});

  useEffect(() => {
    if (src) {
      getSecureImage();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src]);

  const getSecureImage = () => {
    const jwtToken = localStorage.getItem(AUTH_TOKEN);
    setLoading(true);
    let url = `${API_BASE_URL}/api/v1/${folder}/image/${scId}/${src}`;
    if (tag) {
      url = `${API_BASE_URL}/api/v1/${folder}/${tag}/image/${scId}/${src}`;
    }
    fetch(url, {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    })
      .then(res => res.blob())
      .then(imageBlob => {
        // Convierte el blob a un objeto URL para visualizar la imagen
        const imageUrl = URL.createObjectURL(imageBlob);

        // Convierte el blob a un objeto File para extraer los metadatos
        const imageFile = new File([imageBlob], "temp.jpg", { type: imageBlob.type });

        // @ts-ignore
        EXIF.getData(imageFile, function() {
          // @ts-ignore
          const UserComment = EXIF.getTag(this, "UserComment"); // Obtiene un metadato específico

          if (xmlDataScFamilyPhoto) {
            const metaData = processXML(xmlDataScFamilyPhoto);
            if (metaData) {
              setFamilyPhoto(metaData);
            }
          } else if (UserComment) {
            const parser = new DOMParser();
            const xmlDoc: any = parser.parseFromString(UserComment, "application/xml");
            const descriptionTags = xmlDoc.getElementsByTagName("Description");

            if (descriptionTags.length > 0) {
              const metaDataObject = {
                Description: xmlDoc.getElementsByTagName("Description")[0].textContent,
                MonthOfPictureTaken: xmlDoc.getElementsByTagName("MonthOfPictureTaken")[0].textContent,
                YearOfPictureTaken: xmlDoc.getElementsByTagName("YearOfPictureTaken")[0].textContent,
              };
              setFamilyPhoto(metaDataObject);
            }
          }
        });

        setImage(imageUrl);
      })
      .catch(err => {
        console.error(err);
      }).finally(() => {
        setLoading(false);
      });
  }

  const processXML = (xmlString: string) => {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, "application/xml");
    const descriptionTags = xmlDoc.getElementsByTagName("Description");

    if (descriptionTags.length > 0) {
      return {
        Description: descriptionTags[0].textContent,
        MonthOfPictureTaken: xmlDoc.getElementsByTagName("MonthOfPictureTaken")[0].textContent,
        YearOfPictureTaken: xmlDoc.getElementsByTagName("YearOfPictureTaken")[0].textContent,
      };
    }

    return null;
  };

  return <div className='text-center'>
    <Spin spinning={loading} >
      <Row>
        <Col span={24}>
          <Image
            fallback="data:image/png;base64,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"
            src={image ?? ''}
            preview={false}
          />
        </Col>
        {
          (familyPhoto?.Description && viewMetadata) && (
            <Col span={24} className='text-left'>
              <br/>
              <p className='m-0'>{ t('description') }: <b>{ familyPhoto?.Description }</b></p>
              <p className='m-0'>{ t('monthOfPictureTaken') }: <b>{ familyPhoto?.MonthOfPictureTaken }</b></p>
              <p className='m-0'>{ t('yearOfPictureTaken') }: <b>{ familyPhoto?.YearOfPictureTaken }</b></p>
            </Col>
          )
        }
      </Row>
    </Spin>
  </div>;

}

export default ImageWithAuth;
